import React, { useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { coupon, getCouponData } from "../../features/Coupon";
function CouponDropDown(props) {
  const coupondata = useSelector(getCouponData);
  const selectdata = coupondata.map((data) => {
    return {
      value: data.coupon_id,
      label: data.coupon_id + "-" + data[props.column],
    };
  });
  const index = selectdata.findIndex(checkCoupon);
  function checkCoupon(data) {
    return data.value == props.defaultValue;
  }
  return (
    <>
      <div style={{ width: "100%" }}>
        <Select
          options={selectdata}
          onChange={(value) => {
            props?.searchParam
              ? props.searchParam(value.value, "coupon_id")
              : props.coupon_id(value.value);
          }}
          defaultValue={selectdata[index]}
        />
      </div>
    </>
  );
}

export default CouponDropDown;
